import toast from 'react-hot-toast';
import classService from '../../services/classService';

// The server finds these columns by their header text, in any order
export const CLASS_IMPORT_COLUMNS_HINT =
  'File cần có các cột: Tên lớp, Năm học, Tên giáo viên, Mã giáo viên. Lớp chưa có chủ nhiệm thì để trống cả hai cột giáo viên.';

export const CLASS_IMPORT_FORMATS_HINT = 'Hỗ trợ file Excel (.xlsx) hoặc CSV (UTF-8)';

const TEMPLATE_TYPES = {
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  csv: 'text/csv;charset=utf-8',
} as const;

/** Shared by the Class screen and the school's Classes tab, which import through the same endpoints. */
export async function downloadClassTemplate(format: keyof typeof TEMPLATE_TYPES): Promise<void> {
  try {
    const response = format === 'xlsx'
      ? await classService.downloadTemplate()
      : await classService.downloadCsvTemplate();
    const url = window.URL.createObjectURL(new Blob([response.data], { type: TEMPLATE_TYPES[format] }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `class_import_template.${format}`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error(`Failed to download ${format} template:`, error);
    toast.error('Không tải được file mẫu, vui lòng thử lại.');
  }
}
